module.exports = __webpack_public_path__ + "img/20210730_213301.72936ab6.jpg";